export const throttleDefault = () => {
    const wrapper = () => { };
    wrapper.cancel = () => { };
    return wrapper;
};
//# sourceMappingURL=throttleDefault.js.map